@if (languages.length > 0) {
  <div class="language-input">

    <div class="input-wrapper" [class.is-textarea]="isTextarea">
      @if (showTabTooltip) {
        <div class="tab-tooltip" role="status" aria-live="polite">
          <span class="tab-tooltip-text">{{ 'I18N.INPUT.TOOLTIP' | translate }}</span>
          <button type="button" class="tab-tooltip-close" (click)="dismissTabTooltip()" aria-label="Close tooltip">×</button>
          <span class="tab-tooltip-arrow" aria-hidden="true"></span>
        </div>
      }

      <div class="field-wrapper" [class.is-textarea]="isTextarea" [class.is-quill]="isQuillEditor" [class.has-counter]="maxLength !== null">
        @if (isQuillEditor) {
          <quill-editor [disabled]="disabled" 
                        [ngModel]="findCurrentLanguageValue(selectedLanguage)?.Override ?? ''"
                        (ngModelChange)="updateValue($event)" 
                        (onBlur)="onFieldBlur()"
                        [sanitize]="true" 
                        [modules]="quillConfig" 
                        [styles]="{height: '100px'}"
                        class="w-100"></quill-editor>
        } @else if (isTextarea) {
          <textarea [disabled]="disabled" [value]="findCurrentLanguageValue(selectedLanguage)?.Override ?? ''"
                    (input)="updateValue($any($event.target).value)" (blur)="onFieldBlur()"
                    (keydown)="onInputKeydown($event)"
                    [rows]="lines"
                    [placeholder]="fallbackPlaceholder"
                    [attr.maxlength]="maxLength"></textarea>
        } @else {
          <input type="text" [disabled]="disabled" [value]="findCurrentLanguageValue(selectedLanguage)?.Override ?? ''"
                (input)="updateValue($any($event.target).value)" (blur)="onFieldBlur()"
                (keydown)="onInputKeydown($event)"
                [placeholder]="fallbackPlaceholder"
                [attr.maxlength]="maxLength"/>
        }

        @if (maxLength !== null) {
          <div class="char-counter" [class.at-limit]="currentCharCount >= maxLength">
            {{ currentCharCount }} / {{ maxLength }}
          </div>
        }
      </div>

      <button type="button" class="language-button" (click)="dropdownOpen = !dropdownOpen" [disabled]="disabled">
        <span class="flag flag-{{ currentLanguage.Code.toLowerCase() }}"></span>
        <span class="arrow">▾</span>
      </button>

      <div class="language-dropdown" *ngIf="dropdownOpen" >
        <button type="button" *ngFor="let language of languages" class="language-option" (click)="selectLanguage(language.Code)" >
          <span class="flag flag-{{ language.Code.toLowerCase() }}"></span>
          <span class="language-name">{{ language.Name }}</span>
          <span class="status" [class.completed]="hasValue(language.Code)" > {{ hasValue(language.Code) ? '✓' : '' }} </span>
        </button>
      </div>
    </div>
  </div>
}